import colorPickerAccessibleRoleDo from "../../../../src/pages/foundations/color-new/color-picker-swatches/_assets/color-picker-accessible-role-do.png";
import colorPickerAccessibleRoleDont from "../../../../src/pages/foundations/color-new/color-picker-swatches/_assets/color-picker-accessible-role-dont.png";
import colorPickerAgnosticColorDo from "../../../../src/pages/foundations/color-new/color-picker-swatches/_assets/color-picker-agnostic-color-do.png";
import colorPickerAgnosticColorDont from "../../../../src/pages/foundations/color-new/color-picker-swatches/_assets/color-picker-agnostic-color-dont.png";
import colorPickerAgnosticColorLight from "../../../../src/pages/foundations/color-new/color-picker-swatches/_assets/color-picker-agnostic-color-light.png";
import colorPickerAvoidYellowTextDo from "../../../../src/pages/foundations/color-new/color-picker-swatches/_assets/color-picker-avoid-yellow-text-do.png";
import colorPickerAvoidYellowTextDont from "../../../../src/pages/foundations/color-new/color-picker-swatches/_assets/color-picker-avoid-yellow-text-dont.png";
import colorPickerBackgroundsLight from "../../../../src/pages/foundations/color-new/color-picker-swatches/_assets/color-picker-backgrounds-light.png";
import colorPickerChartLight from "../../../../src/pages/foundations/color-new/color-picker-swatches/_assets/color-picker-chart-light.png";
import colorPickerChartRoleDo from "../../../../src/pages/foundations/color-new/color-picker-swatches/_assets/color-picker-role-do.png";
import colorPickerChartRoleDont from "../../../../src/pages/foundations/color-new/color-picker-swatches/_assets/color-picker-role-dont.png";
import colorPickerExampleLight from "../../../../src/pages/foundations/color-new/color-picker-swatches/_assets/color-picker-example-light.png";
import colorPickerTextLight from "../../../../src/pages/foundations/color-new/color-picker-swatches/_assets/color-picker-text-light.png";
import * as React from 'react';
export default {
  colorPickerAccessibleRoleDo,
  colorPickerAccessibleRoleDont,
  colorPickerAgnosticColorDo,
  colorPickerAgnosticColorDont,
  colorPickerAgnosticColorLight,
  colorPickerAvoidYellowTextDo,
  colorPickerAvoidYellowTextDont,
  colorPickerBackgroundsLight,
  colorPickerChartLight,
  colorPickerChartRoleDo,
  colorPickerChartRoleDont,
  colorPickerExampleLight,
  colorPickerTextLight,
  React
};